<ng-dialog-header [title]="dialogTitle"></ng-dialog-header>
<mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="w-100" color="accent">
      <mat-label ngRequired>Origin</mat-label>
      <ns-select formControlName="origin" [useVirtual]="true" [useIncludesSearch]="true">
        <mat-option *ngFor="let origin of origins" [value]="origin.key">{{ origin.value }}</mat-option>
      </ns-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100" color="accent">
      <mat-label ngRequired>Shipper</mat-label>
      <ns-select formControlName="shipper" [useVirtual]="true" [useIncludesSearch]="true">
        <mat-option *ngFor="let shipper of shippers" [value]="shipper.key">{{ shipper.value }}</mat-option>
      </ns-select>
    </mat-form-field>
    <mat-form-field *ngIf="form.controls.requiredTrainType.enabled" appearance="outline" class="w-100" color="accent">
      <mat-label>Required Train Type</mat-label>
      <ns-select formControlName="requiredTrainType" [useIncludesSearch]="true">
        <mat-option *ngFor="let train of trainTypes" [value]="train.key">{{ train.value }}</mat-option>
      </ns-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100" color="accent">
      <mat-label ngRequired># of Cars</mat-label>
      <input matInput formControlName="noOfCars" type="number" aria-label="Car Quantity" min="1" max="999">
      <mat-error *ngIf="form.controls.noOfCars.errors?.min">At least 1 car is required</mat-error>
      <mat-error *ngIf="form.controls.noOfCars.errors?.max">The maximum number of cars is 999</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100" color="accent">
      <mat-label>Product Class</mat-label>
      <ns-select formControlName="productClass" [useVirtual]="true" [useIncludesSearch]="true">
        <mat-option *ngFor="let productClass of productClasses" [value]="productClass.key">{{ productClass.value }}</mat-option>
      </ns-select>
    </mat-form-field>

    <div class="row no-gutters">
      <div class="col-sm-8">
        <mat-form-field appearance="outline" class="w-100" color="accent">
          <mat-label *ngIf="commodity === 'ET'" ngRequired>Deliver By Date</mat-label>
          <mat-label *ngIf="commodity !== 'ET'">Deliver By Date</mat-label>
          <input matInput [matDatepicker]="deliveryByDatePicker" placeholder="Deliver By Date" formControlName="scheduleDeliveryDate"
                 aria-label="Deliver By Date Input"/>
          <mat-datepicker-toggle matSuffix [for]="deliveryByDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #deliveryByDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline" class="w-100" color="accent">
          <mat-label>HH:MM AM/PM</mat-label>
          <ns-select formControlName="scheduleDeliveryTime">
            <mat-option *ngFor="let hh of hoursTimes" [value]="hh.key">{{ hh.value }}</mat-option>
          </ns-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-sm-8">
        <mat-form-field appearance="outline" class="w-100" color="accent">
          <mat-label ngRequired>Scheduled Load</mat-label>
          <input matInput [matDatepicker]="scheduledLoadPicker" placeholder="Scheduled Load" formControlName="scheduleLoadDate"
                 aria-label="Scheduled Load Input"/>
          <mat-datepicker-toggle matSuffix [for]="scheduledLoadPicker"></mat-datepicker-toggle>
          <mat-datepicker #scheduledLoadPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline" class="w-100" color="accent">
          <mat-label>HH:MM AM/PM</mat-label>
          <ns-select formControlName="scheduleLoadTime">
            <mat-option *ngFor="let hh of hoursTimes" [value]="hh.key">{{ hh.value }}</mat-option>
          </ns-select>
        </mat-form-field>
      </div>
    </div>

    <div class="w-100">
      <mat-checkbox formControlName="schLdDtLockDown">Lockdown Original</mat-checkbox>
    </div>
    <mat-form-field appearance="outline" class="w-100" color="accent">
      <mat-label>Trace Car</mat-label>
      <input matInput formControlName="traceCar" aria-label="input trace car">
    </mat-form-field>
    <p *ngIf="form.controls.traceCar.valid">Trace Car Status: TBD</p>

    <mat-form-field *ngIf="form.controls.needByDate.enabled" appearance="outline" class="w-100" color="accent">
      <mat-label>Hot Shipment Date</mat-label>
      <input matInput [matDatepicker]="hotShipmentDatePicker" placeholder="Hot Shipment Date" formControlName="needByDate"
             aria-label="Hot Shipment Date"/>
      <mat-datepicker-toggle matSuffix [for]="hotShipmentDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #hotShipmentDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field *ngIf="form.controls.scheduleInterchangeDate.enabled" appearance="outline" class="w-100" color="accent">
      <mat-label>Schedule Interchange Date</mat-label>
      <input matInput [matDatepicker]="scheduledInterChangePicker" placeholder="Schedule Interchange Date" formControlName="scheduleInterchangeDate"
             aria-label="Schedule Interchange Date"/>
      <mat-datepicker-toggle matSuffix [for]="scheduledInterChangePicker"></mat-datepicker-toggle>
      <mat-datepicker #scheduledInterChangePicker></mat-datepicker>
    </mat-form-field>

    <div *ngIf="form.controls.schIchDtLockDown.enabled" class="w-100">
      <mat-checkbox formControlName="schIchDtLockDown">Lockdown Original Interchange</mat-checkbox>
    </div>
    <mat-form-field *ngIf="form.controls.cducomments.enabled" appearance="outline" class="w-100" color="accent">
      <mat-label>UT Remarks</mat-label>
      <input matInput formControlName="cducomments" aria-label="UT Remarks">
    </mat-form-field>
  </form>
</mat-dialog-content>
<ng-dialog-footer>
  <div dialog-actions class="d-flex justify-content-end w-100">
    <button mat-stroked-button color="warn" aria-label="Cancel permit search" mat-dialog-close>Cancel</button>
    <button mat-flat-button type="button" [disabled]="!form.valid" color="accent"
            aria-label="Next Shipment" (click)="shipment ? update() : next()">{{ nextButtonText }}</button>
  </div>
</ng-dialog-footer>
